<template>
    <v-btn
      class="base-dropdown-btn"
      :class="[
        loading ? 'loader-on' : '',
      ]"
      :text="filled ? undefined : true"
      elevation="0"
      :to="to ? to : null"
      :target="target ? target : null"
      :href="href ? href : null"
      v-on="on ? on : null"
      v-bind="attrs ? attrs : null"
      :disabled="disabled"
      large
    >
        <v-icon
            v-if="!loading"
            size="16"
            :class="color ? `${color}--text` : `heading--text`"
            >{{ icon }}</v-icon
        >
        <div v-else class="d-flex justify-center align-self-center align-center loading-container">
            <loader
            :color="color ? color : 'primary'"
            size="20"
            :noMargins="true"
            />
        </div>
        <div v-if="!loading"
            class="p-d v-btn__text"
            :class="[color ? `${color}--text` : '', loading ? 'loading' : '']"
            v-html="text"
        ></div>
    </v-btn>
  </template>
  
  <script>
  import Loader from "../Loader.vue";
  
  export default {
    components: {
      Loader,
    },
    props: {
      small: Boolean,
      icon: String,
      text: String,
      to: String,
      href: String,
      on: Object,
      attrs: Object,
      color: String,
      filled: Boolean,
      target: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .v-btn {
    .loading-container {
      min-width: 34px;
      min-height: 34px;
    }
    &.primary-btn {
      &::v-deep {
        .v-btn__text {
          color: map-get($primary, darken1);
        }
        .v-icon {
          color: map-get($primary, darken1) !important;
        }
      }
    }
  }
  .v-application--is-rtl{
      .v-btn--vertical{
          .v-icon{
              margin-left: 0px;
          }
      }
  }
  </style>
  